import React from 'react'
import { Assesment } from '@rankmi/ats-app'
const AssessmentView = () => {

  return(
    <Assesment/>
  )
}

export default AssessmentView
